import React, { useState } from "react";
import {
  BsPerson,
  BsEnvelope,
  BsBuilding,
  BsTelephone,
  BsChatLeftText,
  
} from "react-icons/bs";

const reasons = [
  "UKG Certified Consultants with 15+ years experience",
  "Global presence across US, India, and Brazil",
  "Proven track record with Fortune 500 companies",
  "24/7 dedicated support services",
];

export default function GetInTouch() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

 const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    await fetch(
      "https://script.google.com/macros/s/AKfycbyYx7J8oUdVww9AtayM00igah3ufc-vLgIyAto50r9GIq0WcB96t0YBjbBiLPK-oSwvNQ/exec",
      {
        method: "POST",
        mode: "no-cors",   // REQUIRED for Apps Script
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      }
    );

    alert("Message sent successfully!");
    setFormData({
      name: "",
      email: "",
      company: "",
      phone: "",
      message: "",
    });

  } catch (err) {
    alert("Error submitting form");
  }
};



  return (
    <section className="py-5" id="contact">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">Get in Touch</h2>
          <p className="text-muted">
            Ready to transform your workforce management? <br/> Contact us today to discuss how 5 Helms can help optimize your UKG implementation.
          </p>
        </div>

        <div className="row g-5">
          {/* Left */}
          <div className="col-lg-6">
            <h5 className="fw-bold mb-4">Why Choose 5 Helms?</h5>
            <ul className="list-unstyled">
  {reasons.map((item, i) => (
    <li key={i} className="d-flex mb-3 align-items-start">
      {/* Custom SVG Icon */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-5 h-5 text-primary flex-shrink-0 me-2 mt-1"
      >
        <circle cx="12" cy="12" r="10"></circle>
        <path d="m9 12 2 2 4-4"></path>
      </svg>

      {item}
    </li>
  ))}
</ul>

            <div className="col-md-9">
              <div className="why-card h-100 text-start p-3 border rounded">
                 <p><b>Quick Response Guarantee</b></p>
                <p className="text-muted mb-0">
                  Our team responds to all inquiries within 24-48 business hours. For urgent matters, please indicate in your message.
                </p>
              </div>
            </div>
          </div>

          {/* Form */}
          <div className="col-lg-5">
            <form onSubmit={handleSubmit} className="p-4 border rounded">
              
              {/* Full Name */}
              <div className="mb-3">
                <label className="form-label">Full Name *</label>
                <div className="input-group">
                  <span className="input-group-text bg-light">
                    <BsPerson />
                  </span>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="John Smith"
                    required
                  />
                </div>
              </div>

              {/* Email */}
              <div className="mb-3">
                <label className="form-label">Email Address *</label>
                <div className="input-group">
                  <span className="input-group-text bg-light">
                    <BsEnvelope />
                  </span>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="john@company.com"
                    required
                  />
                </div>
              </div>

              {/* Company & Phone */}
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Company</label>
                  <div className="input-group">
                    <span className="input-group-text bg-light">
                      <BsBuilding />
                    </span>
                    <input
                      type="text"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Acme Inc."
                    />
                  </div>
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">Phone</label>
                  <div className="input-group">
                    <span className="input-group-text bg-light">
                      <BsTelephone />
                    </span>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="+1 (555) 123-4567"
                    />
                  </div>
                </div>
              </div>

              {/* Message */}
              <div className="mb-3">
                <label className="form-label">Message *</label>
                <div className="input-group">
                  <span className="input-group-text bg-light">
                    <BsChatLeftText />
                  </span>
                  <textarea
                    rows="4"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Tell us about your project and how we can help..."
                    required
                  />
                </div>
              </div>

              <button type="submit" className="btn btn-primary w-100">
                Send Message
              </button>

              <p className="mt-2 text-muted small">
                By submitting this form, you agree to our privacy policy. We'll never share your information with third parties.
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
